export default __webpack_public_path__ + "static/media/AvenirLTProBook.5ce15f85.otf";